const forms = [
  {
    name: "Timesheet",
    className: "bg-white p-4 rounded-md p-8 w-[90%] mx-auto",
    options: [
      {
        name: "Date",
        type: "date",
        form: {
          type: "text",
          name: "date",
          placeholder: "Date",
          class: "",
          value: "",
          required: true,
        },
      },
    ],
  },
];

export default forms;
